import { render, staticRenderFns } from "./wechatChange.vue?vue&type=template&id=11c9757b&scoped=true&"
import script from "./wechatChange.vue?vue&type=script&lang=js&"
export * from "./wechatChange.vue?vue&type=script&lang=js&"
import style0 from "./wechatChange.vue?vue&type=style&index=0&id=11c9757b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c9757b",
  null
  
)

export default component.exports